import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null,
    },
    versione: "3.11.6",
    testo_azienda: "",
    pagina_attuale: "",
    check_paginaAttuale: 0,
    task_validi: 0,
    task_scaduti: 0,
    conferma_cambio_rotta: false,
    rotta_to: null,
    rotta_from: null,
    show_admin_tools: localStorage.id_profilo_utente == 1 ? true : false,
    menu_sx: [],
    stack_query: new Array(),
    snackbar: {
      stato: false,
      messaggio: "",
      colore: "success",
    },
    token: localStorage.getItem("user_token") || "",
    config: {
      db_name: "medical",
      ip: "",
    },
    id_utente: localStorage.getItem("id") || "",
    status: "",
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    setInfo(state, data) {
      state.config = data.config;
    },
    api_request(state) {
      state.status = "loading";
    },
    close_snackbar(state) {
      setTimeout(() => {
        state.snackbar.stato = false;
      }, 3000);
    },
  },
  actions: {
    fetchUser({ commit }, user) {
      // console.log("firebase us", user);
      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email,
          id: user.uid,
          creato: user.metadata.a,
        });
      } else {
        commit("SET_USER", null);
      }
    },
    connext({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("api_request");
        axios({
          url:
            localStorage.getItem("quickconnext_backend") +
            "api/" +
            data.controller,
          data: data.richiesta,
          method: data.method,
        })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            if (
              err.response == undefined ||
              err.response.status == 401 ||
              err.response.status == 403 ||
              err.status == 401 ||
              err.status == 403
            ) {
              this.$logout();
              console.log("logout", data);
              router.push("/login").catch(() => {});
            }
            reject(err);
          });
      });
    },

    api({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("api_request");

        const chiaveFirma = "BFh2NjgftoJmQxdYFxeIRRy2YqMwr35il8PVzV5Isls=";
        const encoder = new TextEncoder();
        const arr = encoder.encode(
          JSON.stringify(data.richiesta) + chiaveFirma
        );
        crypto.subtle.digest("SHA-256", arr).then((firma) => {
          data.richiesta.firma = btoa(
            String.fromCharCode(...new Uint8Array(firma))
          );

          console.log(store.state.config.ip + "api/" + data.controller);
          axios({
            url: store.state.config.ip + "api/" + data.controller,
            data: data.richiesta,
            method: data.method,
          })
            .then((resp) => {
              resolve(resp);
            })
            .catch((err) => {
              if (
                err.response == undefined ||
                err.response.status == 403 ||
                err.status == 403
              ) {
                this.$handleError(data);
              } else if (err.response.status == 401 || err.status == 401) {
                this.$handleUnauthorized();
              }
              reject(err);
            });
        });
      });
    },
    api6({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("api_request");

        const chiaveFirma = "BFh2NjgftoJmQxdYFxeIRRy2YqMwr35il8PVzV5Isls=";
        const encoder = new TextEncoder();
        const arr = encoder.encode(
          JSON.stringify(data.richiesta) + chiaveFirma
        );
        crypto.subtle.digest("SHA-256", arr).then((firma) => {
          data.richiesta.firma = btoa(
            String.fromCharCode(...new Uint8Array(firma))
          );

          axios({
            url: store.state.config.api6 + "api/" + data.controller,
            data: data.richiesta,
            method: data.method,
          })
            .then((resp) => {
              resolve(resp);
            })
            .catch((err) => {
              if (
                err.response == undefined ||
                err.response.status == 403 ||
                err.status == 403
              ) {
                this.$handleError(data);
              } else if (err.response.status == 401 || err.status == 401) {
                this.$handleUnauthorized();
              }
              reject(err);
            });
        });
      });
    },
    api_blob({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("api_request");
        axios({
          url: store.state.config.ip + "api/" + data.controller,
          data: data.richiesta,
          method: data.method,
          responseType: "blob",
        })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            if (
              err.response == undefined ||
              err.response.status == 401 ||
              err.response.status == 403 ||
              err.status == 401 ||
              err.status == 403
            ) {
              this.$logout();
              console.log("logout", data);
              router.push("/login").catch(() => {});
            }
            console.error(err);
            reject(err);
          });
      });
    },
    api_array_buffer({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("api_request");
        axios({
          url: store.state.config.ip + "api/" + data.controller,
          data: data.richiesta,
          method: data.method,
          responseType: "arraybuffer",
        })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            if (
              err.response == undefined ||
              err.response.status == 401 ||
              err.response.status == 403 ||
              err.status == 401 ||
              err.status == 403
            ) {
              this.$logout();
              console.log("logout", data);
              router.push("/login").catch(() => {});
            }
            console.error(err);
            reject(err);
          });
      });
    },
    // getInfo({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get("http://localhost:8080/config2.json")
    //       .then((response) => {
    //         commit("setInfo", response.data);
    //         resolve(response);
    //         return;
    //       })
    //       .catch((e) => {
    //         reject(e);
    //         console.log(e);
    //       });
    //   }
    // );
    // },
  
  },
  modules: {},
});
